import React, { useContext, useState, useEffect } from "react";
import styles from "./index.module.less";
import { ThirdAppContext } from "@/components/ThirdApp/utils";
import IconFont, { getIconFromString } from "@/components/icon";
import { Dropdown, Space, Menu } from "antd";
import { connect } from "dva";
import "./index.less";
import { changeEgovUrl } from "@/utils/tools";
import bus from "@/utils/bus";
interface IProps {
  openAppStore?: () => void;
  onManageFavoriteApp?: () => void;
  onManageCard?: () => void;
  hasNewStoreApp?: boolean;
  workbenchList?: any;
  setWorkbenchList?: Function;
  currentSelectedWorkbench?: any;
  getAppListAll: Function;
  getWorkbenchList: Function;
  localstorageKey: string;
}

function ThirdAppHeader({
  openAppStore,
  onManageFavoriteApp,
  onManageCard,
  hasNewStoreApp,
  workbenchList,
  setWorkbenchList,
  currentSelectedWorkbench,
  getAppListAll,
  getWorkbenchList,
  localstorageKey
}: IProps) {
  const { isOnline, isActive } = useContext(ThirdAppContext);
  const [dropdownIsVisible, setDropdownIsVisible] = useState(false);

  const showAppstore = false

  useEffect(() => {
    bus.on("workbenchRefreshCb", refreshWorkbench);

    return () => {
      bus.off("workbenchRefreshCb", refreshWorkbench);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function openSetting() {
    onManageFavoriteApp?.();
  }
  function openManageCard() {
    onManageCard?.();
  }

  const dropdownMenuOnClick = ({ key }: any) => {
    let selectedWorkbench = null;
    let index = workbenchList.findIndex((workbenchData: any) => {
      return workbenchData.workBenchId === key;
    });
    selectedWorkbench = { ...workbenchList[index] };
    workbenchList.splice(index, 1);
    workbenchList.unshift(selectedWorkbench);
    let historySelectedWorkbenchString = window.localStorage.getItem("currentSelectedWorkbench");
    let historySelectedWorkbench = historySelectedWorkbenchString
      ? JSON.parse(historySelectedWorkbenchString)
      : {};
    for (let key in historySelectedWorkbench) {
      if (
        key === "customUnitGroupName" ||
        key === "logoImage" ||
        key === "mobileNaviImage" ||
        key === "pcNaviImage" ||
        key === "workBenchId" ||
        key === "workBenchName" ||
        key === "workBenchType"
      ) {
        delete historySelectedWorkbench[key];
      }
    }
    window.localStorage.setItem(
      "currentSelectedWorkbench",
      JSON.stringify({ ...historySelectedWorkbench, [localstorageKey]: selectedWorkbench })
    );
    setWorkbenchList?.({
      workbenchList: [...workbenchList],
      currentSelectedWorkbench: selectedWorkbench
    });
    setDropdownIsVisible(false);
  };

  const menu = (
    <Menu selectedKeys={[currentSelectedWorkbench.workBenchId]} onClick={dropdownMenuOnClick}>
      {workbenchList.map((workbenchData: any) => {
        return <Menu.Item key={workbenchData.workBenchId}>{workbenchData.workBenchName}</Menu.Item>;
      })}
    </Menu>
  );

  const dropdownOnVisibleChange = (visible: boolean) => {
    setDropdownIsVisible(visible);
  };

  const refreshWorkbench = () => {
    getWorkbenchList({ localstorageKey });
    if (currentSelectedWorkbench.workBenchType === 0) {
      getAppListAll();
    }
  };

  useEffect(() => {
    if (isActive && isOnline) {
      getWorkbenchList({ localstorageKey });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive, localstorageKey, isOnline]);

  return (
    <div className={styles["header"]}>
      <div className={styles["header-left-box"]}>
        {currentSelectedWorkbench.workBenchType === 1 ? (
          <img
            alt="工作台icon"
            src={changeEgovUrl(currentSelectedWorkbench.logoImage)}
            className={styles["workbench-logo"]}
          />
        ) : (
          ""
        )}
        <div className={styles["title_label"]}>
          {workbenchList.length <= 1 ? (
            currentSelectedWorkbench?.workBenchName || ""
          ) : (
            <Dropdown
              overlay={menu}
              overlayClassName="workbench-dropdown"
              getPopupContainer={(trigger) => {
                return trigger.parentNode as HTMLElement;
              }}
              onVisibleChange={dropdownOnVisibleChange}
              trigger={["click"]}
            >
              <Space className="title_label_text">
                {currentSelectedWorkbench.workBenchName}
                <span className={styles["change_text"]}>切换</span>
                {/* {dropdownIsVisible ? (
                  <IconFont
                    type="iconic_title_down"
                    style={{ fontSize: "8px", color: "#62656D" }}
                  />
                ) : (
                  <IconFont type="iconic_title_up" style={{ fontSize: "8px", color: "#62656D" }} />
                )} */}
              </Space>
            </Dropdown>
          )}
        </div>
      </div>
      <div className={styles["tools"]}>
        { showAppstore && <div
          className={styles["label"]}
          onClick={() => {
            if (!isOnline) {
              return false;
            }
            openAppStore?.();
          }}
        >
          <IconFont
            type="iconic_pc_appmarket"
            className={styles["icon"]}
            style={{ fontSize: "17px" }}
          />
          {hasNewStoreApp && <span className={styles["third-left-nav_red_dot"]} />}
          <span className={styles["text"]}>应用市场</span>
        </div>}
        {currentSelectedWorkbench.workBenchType === 0 && (
          <>
            <div className={styles["label"]} onClick={openSetting}>
              <IconFont
                type="iconic_app_set"
                className={styles["icon"]}
                style={{ fontSize: "16px" }}
              />
              <span className={styles["text"]}>管理应用</span>
            </div>
            <div className={styles["label"]} onClick={openManageCard}>
              <IconFont
                type="iconic_app_question_head"
                className={styles["icon"]}
                style={{ fontSize: "15px" }}
              />
              <span className={styles["text"]}>管理卡片</span>
            </div>
          </>
        )}
        {/* <div className={styles["label"]} onClick={refreshWorkbench}>
          <IconFont
            className={`${styles["refresh"]} ${styles["icon"]}`}
            type="iconic_pc_refresh11"
            style={{ fontSize: "16px" }}
          />
          <span className={styles["text"]}>刷新</span>
        </div> */}
      </div>
    </div>
  );
}
function mapStateToProps({ workbench }: { workbench: any }) {
  const { workbenchList, currentSelectedWorkbench } = workbench;
  return {
    workbenchList,
    currentSelectedWorkbench
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    setWorkbenchList(data: any) {
      dispatch({ type: "workbench/setWorkbenchList", payload: data });
    },
    getWorkbenchList(data: any) {
      dispatch({ type: "workbench/getWorkbenchList", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThirdAppHeader);
